/** Genemo Post 自身の画面（ペルソナ画面の接続ボタン・フォーム・接続後の行）のイメージ */
import { Mark, MockButton, MockInput, PostScreen } from './parts'

const BUTTONS = ['WordPress を接続（準備中）', 'X を接続（自分のキー）', 'Threads を接続（トークン）', 'Instagram を接続（トークン）'] as const
export type ConnectButton = Exclude<typeof BUTTONS[number], 'WordPress を接続（準備中）'>

/** ペルソナのカードと接続ボタン。押すボタンに印をつける */
export function ConnectButtonsMock({ highlight, n = 1 }: { highlight: ConnectButton; n?: number }) {
  return (
    <PostScreen title="/personas">
      <div className="mb-2 text-[13px] font-bold">ペルソナ</div>
      <div className="rounded-md border border-line p-2.5">
        <div className="text-[12.5px] font-bold">本店の中の人 <span className="font-normal text-ink-muted">ジェネモ珈琲</span></div>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {BUTTONS.map(b => b === highlight
            ? <Mark key={b} n={n}><MockButton>{b}</MockButton></Mark>
            : <span key={b} className={b.includes('準備中') ? 'opacity-50' : ''}><MockButton>{b}</MockButton></span>)}
        </div>
      </div>
    </PostScreen>
  )
}

/** 接続フォーム（貼る欄と「接続する」） */
export function ConnectFormMock({ note, fields, n = 2 }: { note?: string; fields: Array<{ label: string; value: string; secret?: boolean }>; n?: number }) {
  return (
    <PostScreen title="/personas">
      <div className="space-y-2 rounded-md border border-line p-2.5">
        {note && <p className="text-[11.5px] text-ink-muted">{note}</p>}
        {fields.map(f => <MockInput key={f.label} {...f} />)}
        <Mark n={n}><MockButton>接続する</MockButton></Mark>
      </div>
    </PostScreen>
  )
}

/** 接続できた後の行（状態「接続中」と投稿方針） */
export function ChannelRowMock({ platform, handle, policy = '承認したものだけ投稿', extra }: { platform: string; handle: string; policy?: string; extra?: string }) {
  return (
    <PostScreen title="/personas">
      <div className="rounded-md border border-line p-2.5">
        <div className="text-[12.5px] font-bold">本店の中の人 <span className="font-normal text-ink-muted">ジェネモ珈琲</span></div>
        <div className="mt-2 flex flex-wrap items-center gap-1.5">
          <span className="font-bold">{platform}</span>
          <Mark n="✓"><span className="gm-chip gm-chip-ok">接続中</span></Mark>
          <span className="text-ink-muted">{handle}</span>
          <span className="ml-auto rounded-md border border-line-strong px-2 py-0.5 text-[11.5px]">{policy} ▾</span>
          {extra && <MockButton>{extra}</MockButton>}
        </div>
      </div>
    </PostScreen>
  )
}
